import React from 'react'

function News() {
  const page = "news";
  return (
    <div>
      <section className={`hero ${page}`}>
        <h1>News</h1>
      </section>

      <section className="news">
        <div className="news__wrap">
          <div className="news__content">
            <h3>08/09/2025</h3>
            <h2>
              Drilling Materials Company Participates in Metal & Steel Middle East 2025 Cairo, Egypt - <strong>September 6-8, 2025</strong> 
            </h2>
            <p>
              Drilling Materials Company was proud to be represented at the Metal & Steel Middle East 2025 Exhibition, held at the Egypt International 
              Exhibitions Center from September 6th to 8th. Our dedicated Marketing Representative Mr. Luca Cannizzaro was on the ground engaging with 
              industry leaders, discovering new technologies, and exploring future collaborations.
            </p>
            <p>
              This premier international event brought together leading professionals and innovators from the fields of wire, tube, cable, steel, metal 
              working, CNC technology, and fabrication. As a key player in the region, our presence reinforced our commitment to staying at the forefront of 
              the industrial and manufacturing landscape.
            </p>
            <p>
              <em>“Participating in such a global platform not only strengthens our market visibility but also opens doors for partnerships that drive innovation 
              in drilling materials and beyond.”</em> 
            </p>
            <p>
              We thank the organizers for a well-executed event and look forward to building on the connections and insights gained during these three impactful days.
            </p>
            <p>
              Stay tuned for more updates from our team as we continue to advance and grow across the Middle East and beyond.
            </p>
          </div>


          <figure className="news__media">
            <img src="/assets/images/news/exhibition.jpg" alt="Exhibition" />
          </figure>

        </div>
      </section>

      <section className="news">
        <div className="news__wrap">
          <figure className="news__media">
            <img src="/assets/images/news/grow-with-sap.jpg" alt="grow with SAP" />
          </figure>

          <div className="news__content">
            <h3>25/07/2025</h3>
            <h2>
              SAP S/4HANA Integration: Driving Intelligent Operations with ML & BI
            </h2>
            <p>
              DMCO is proud to announce strong progress in the implementation of our <strong>SAP S/4HANA Integration Project</strong>, with a focus on transforming our 
              operations through <strong>Machine Learning (ML)</strong> and <strong>Business Intelligence (BI)</strong> technologies.
            </p>
            <p>
              This next-generation ERP system enables us to:
            </p>
            <ul>
              <li>Automate key decisions using predictive analytics and ML algorithms</li>
              <li>Gain deeper operational visibility through real-time dashboards and smart reporting</li>
              <li>Optimize inventory, procurement, and production planning using intelligent forecasting tools</li>
            </ul>
            <p>
              “Participating in such a global platform not only strengthens our market visibility but also opens doors for partnerships that drive innovation 
              in drilling materials and beyond.”
            </p>
            <p>
              Currently, core modules are being tested internally, with full go-live targeted for Q4 2025. This initiative is more than just a systems upgrade — it's a leap toward data-driven decision-making, increased agility, and future-ready digital infrastructure.
            </p>
            <p>
              SAP S/4HANA will empower every department at DMCO with faster insights, smarter workflows, and seamless integration across the supply chain.
            </p>
          </div>

        </div>
      </section>  

      <section className="news">
        <div className="news__wrap">
          <div className="news__content">
            <h3>20/07/2025</h3>            
            <h2>
              Project Battery Filler: Quality Testing Underway
            </h2>
            <p>
              We are excited to share that our raw material for the Battery Filler Project is currently undergoing a series of rigorous testing — both locally and in a certified European laboratory — as part of the customer qualification process. This marks a significant milestone in aligning our product with international performance and safety standards.
            </p>
            <p>
              For more information, please contact us at <strong>info@mawad-drilling.com</strong> or call <strong>+966 53 978 0880</strong>.
            </p>
          </div>


          <figure className="news__media">
            <img src="/assets/images/news/Battery-Filler.jpg" alt="Exhibition" />
          </figure>

        </div>
      </section>

      <section className="news">
        <div className="news__wrap">
          <figure className="news__media">
            <img src="/assets/images/news/supply-chain.jpg" alt="Supply Chain" />
          </figure>
          <div className="news__content">
            <h3>08/06/2025</h3>
            <h2>
              Supply Chain Development: New Material Evaluation in Progress
            </h2>
            <p>
              In our commitment to ensuring excellence and consistency, several <strong>new materials</strong> from potential suppliers are now undergoing our internal <strong>quality control procedures</strong>. As part of our robust vendor onboarding process, on-site <strong>supplier facility audits</strong> are planned to confirm production capabilities and alignment with DMCO's standards.
            </p>
            <p>
              Next, controlled pilot runs at DMCO will validate process fit, yield stability, and total landed cost. A cross-functional scorecard (Quality, Production, Procurement, Finance, HSE) will assess capacity, lead times, ISO 9001/14001/45001 status, and ESG compliance. Qualified materials will be added to the Approved Vendor List (AVL) and released for commercial orders, with an update published upon completion.
            </p>
          </div>
        </div>
      </section>      

      <section className="news">
        <div className="news__wrap">
          <div className="news__content">
            <h3>06/06/2025</h3>
            <h2>
              DMCO Team Celebrates Eid al-Adha 2025
            </h2>
            <p>
              Dammam, Saudi Arabia — Drilling Materials Company (DMCO) marked the blessed occasion of Eid al-Adha 2025 with a warm team gathering at our Dammam office. Colleagues from across operations and support functions came together to share sweets, snacks, and reflections on the year so far.
            </p>
            <p>
              The celebration was a simple thank-you to everyone for their dedication and teamwork during a pivotal year for DMCO. Moments like these remind us that behind every shipment, every solution, and every improvement, there’s a committed team working as one.
            </p>
            <h4>Highlights</h4>
            <ul>
              <li>Team get-together and refreshments at the Dammam office</li>
              <li>Appreciation for colleagues supporting customers during the holiday period</li>
              <li>Renewed focus on safety, service quality, and collaboration across departments</li>
            </ul>
            <p>
              From all of us at DMCO, Eid Mubarak—may this season bring peace, prosperity, and continued success to our customers, partners, and team.
            </p>
          </div>
          <figure className="news__media">
            <img src="/assets/images/news/eid-al-adha.jpg" alt="Exhibition" />
          </figure>

        </div>
      </section>

    </div>
  )
}

export default News